import { useNavigoSelection } from '@/atoms'
import { useMapSelectionMode } from '@/map'

export const useShowSubmenu = () => {
  const { selectedCategories } = useNavigoSelection()
  const [mode] = useMapSelectionMode()

  return mode === 'normal' && selectedCategories.length > 0
}
